// Leaflet einmalig laden und global bereitstellen.
// Plugins wie leaflet.markercluster (UMD) erwarten ein globales `window.L`,
// das im CRA/Webpack-Build sonst fehlt. Dieses Modul MUSS vor dem Plugin-Import
// ausgewertet werden (deshalb als eigener Import ganz oben in FotoKarte.js).
import L from 'leaflet';
if (typeof window !== 'undefined' && !window.L) window.L = L;
export default L;
